import TreeEditor from './tree_editor.js';
import { KeyboardNavigation } from './Shared/keyboard_navigation.js';
import { CookieUtils } from './Shared/cookies/cookie-utils';

///////////////////////////////////////////////////////////////////////////////
// INIT

onDomReady(function () {
   // If there was a conflict always allow the user to save.
   let onModified;
   let saveBtn = $('saveStep');

   $$('.edit-title-link').addEvent('click', function (ev) {
      this.getParent('.step-title').hide();
      $('editStepTitle').show('inline-block');
      $('editStepTitleInput').focus();
   });

   if (!$('currentStepView')) {
      onModified = function (modified) {
         if (modified) {
            saveBtn.enable();
            $$('.step-container .js-copy-step-lines').set('disabled', 'disabled');
         } else {
            saveBtn.disable();
         }
      };
   } else {
      saveBtn.enable();
      onModified = function () {};
   }

   let status = new StatusNotice();
   $$('.statuses').adopt(status.element);
   let errorHandler = function (error) {
      status.error(error.message);
   };

   // The EditorManager managers the other managers!
   let stepEditor = new EditorManager({
      errorHandler: errorHandler,
      modifiedHandler: onModified,
   });

   let titleModifiedHandler = stepEditor.getSetModifiedFunction();

   let handleInput = function (value) {
      let message = value ? value : _js('Add a title');
      let edit = $('editStepTitle');
      let view = edit.getSiblings('.step-title');
      let viewValue = view.getElement('.stepTitleValue');

      viewValue.set('text', message);
      viewValue.set('title', message);

      edit.hide();
      view.show();

      if (value !== App.currentStepTitle) {
         saveBtn.enable();
         titleModifiedHandler();
      }
   };

   when($('editStepTitleInput'), function (stepTitleInput) {
      stepTitleInput.addEvents({
         focus: function () {
            saveBtn.enable();
         },
         blur: function () {
            handleInput(this.value.trim());
         },
         keydown: function (ev) {
            if (ev.key == 'enter' || ev.key == 'esc') {
               handleInput(this.value.trim());
            }
         },
      });
   });

   // If another edit has occurred, allow for this to be saved.
   when($('confirmOverride'), function (el) {
      saveBtn.enable();
   });

   let treeEditor = new TreeEditor($('stepLines'), stepEditor);

   let apiFailureHandler = function (xhr, message) {
      if (xhr.status === 409) {
         new Request.AjaxIO('getStepConflict', {
            onSuccess: function (stepConflict) {
               $('stepStatusDiv').set('html', stepConflict.statusHtml);
               // We don't support this feature yet for steptranslations.
               if (!App.stepApi.isTranslate) {
                  $('stepConflictDiv').set('html', stepConflict.stepHtml);
                  App.stepApi.path = stepConflict.patchPath;
               }

               StatusPanel.deactivate();
            }.bind(this),
         }).send(App.stepApi.stepid);
      } else {
         let stepStatusDiv = $('stepStatusDiv');
         let notice = new StatusNotice();
         notice.error(message);
         stepStatusDiv.adopt(notice.element);

         new Fx.Scroll(window).toElement(stepStatusDiv);

         StatusPanel.deactivate();
      }

      saveBtn.enable();
   };

   let signoffTeamDetailTemplate = window.guideHbsTemplates('SIGNOFF_TEAM_DETAIL_HBS');

   when($('signoffForm'), function (signoffForm) {
      let chkbx = $('signoffEnabledCheckbox');
      let teamSignoffRadio = signoffForm.getElementById('teamSignoffRadio');
      let selfSignoffRadio = signoffForm.getElementById('selfSignoffRadio');
      let searchSignoffTeams = signoffForm.getElementById('searchSignoffTeams');
      let signoffTeamSelection = signoffForm.getElementById('signoffTeamSelection');
      let signoffSaveBtn = $('signoffSaveBtn');

      chkbx.addEvent('change', function (ev) {
         if (!chkbx.checked) {
            signoffTeamSelection.empty();
         }

         signoffForm.getElements('input[name="signoff"]').each(function (input) {
            if (!chkbx.checked) {
               input.checked = false;
               signoffSaveBtn.enable();
            } else {
               input.enable();
            }
         });

         searchSignoffTeams.disabled = !teamSignoffRadio.checked;
      });

      teamSignoffRadio.addEvent('click', function (ev) {
         searchSignoffTeams.enable();
         if (!signoffTeamSelection.childElementCount) {
            signoffSaveBtn.disable();
         }
      });

      selfSignoffRadio.addEvent('click', function (ev) {
         searchSignoffTeams.disable();
         signoffSaveBtn.enable();
      });

      signoffSaveBtn.addEvent('click', function (ev) {
         let method = !chkbx.checked ? 'delete' : 'put';
         let url = App.signoffApi.path;

         if (chkbx.checked) {
            if (teamSignoffRadio.checked) {
               url += '/' + signoffTeamSelection.get('data-teamid');
            } else if (selfSignoffRadio.checked) {
               url += App.signoffApi.selfSignoff;
            }
         }

         Auth.required({
            message: _js('Log in to save signoff options.'),
            reload: false,
            onAuthorize: function () {
               let request = new Request.API_2_0(url, {
                  method: method,
                  onSuccess: function (response) {
                     signoffSaveBtn.disable();
                  },
               });

               LoadingIndicator.withPromise(request.send(), {
                  pendingMessage: _js('Saving signoff options'),
                  successMessage: _js('Saved'),
                  failureMessage: _js('Signoff options were not saved'),
               });
            },
         });
      });
   });

   when($('searchSignoffTeams'), function (input) {
      new TeamFinder(input, {
         indicator: $('signoffTeamSearchSpinner'),
         onSelection: function (el) {
            if (typeof el !== 'object') {
               return;
            }

            let team = el.retrieve('team');
            let signoffTeamSelection = $('signoffTeamSelection');
            signoffTeamSelection.empty();
            signoffTeamSelection.adopt(signoffTeamDetailTemplate(team));
            signoffTeamSelection.setAttribute('data-teamid', team.teamid);
            $('signoffSaveBtn').enable();
         },
      });
   });

   let clickedSave = false;
   $('guideStepForm').addEvent('submit', function (ev) {
      clickedSave = true;
      ev.stop();

      let form = $('guideStepForm');
      stepEditor.save(function () {
         Auth.required({
            from: saveBtn,
            message: _js('Log in to save this step.'),
            onAuthorize: function () {
               // Disable the Save button after submitting.
               saveBtn.disable();

               StatusPanel.loading(_js('Saving...'), 100);

               new Request.API_2_0(App.stepApi.path, {
                  method: App.stepApi.method,
                  onSuccess: function (response) {
                     let stepid;

                     if (App.stepApi.orderby) {
                        // Step creation responds with the full guide. Also,
                        // orderby is 1-indexed but the array isn't.
                        stepid = response.steps[App.stepApi.orderby - 1].stepid;
                     } else {
                        stepid = response.stepid;
                     }

                     CookieUtils.set('step_state', 'SAVED', {
                        maxAgeInSeconds: 2,
                     });

                     if (App.stepApi.isTranslate) {
                        StatusPanel.deactivate();
                        StatusPanel.notify(_js('Saved successfully.'));
                     } else {
                        window.location = App.stepApi.baseStepEditPath + stepid;
                     }
                  }.bind(this),
                  onFailure: apiFailureHandler,
               }).send(getFormValues());
            },
         });
      });
   });

   when($('deleteStep'), function (a) {
      a.addEvent('click', function (ev) {
         ev.stop();

         let confirmMessage =
            _js('Are you sure you want to delete this step?') +
            '\n' +
            _js('Any attached comments will also be removed.');

         if (App.stepForm !== null) {
            confirmMessage += '\n\n' + _js('All forms and historical work data will also be lost.');
         }

         if (confirm(confirmMessage)) {
            Auth.required({
               from: $('deleteStep'),
               message: _js('Log in to delete this step.'),
               onAuthorize: function () {
                  StatusPanel.loading(_js('Deleting...'), 100);

                  new Request.API_2_0(App.stepApi.path, {
                     method: 'DELETE',
                     onSuccess: function (response) {
                        window.location = App.stepApi.guideEditPath;
                     },
                     onFailure: apiFailureHandler,
                  }).send();
               },
            });
         }
      });
   });

   // If the editor has modifications on page unload, warn the user.
   Utils.UnsavedChanges.addHandler(function () {
      if (stepEditor.modified && !clickedSave) {
         return _js('You have unsaved modifications. Your changes will be lost if you continue.');
      }
   });

   let stepImageTargets = [];

   when($('stepThumbsList'), function (stepThumbsList) {
      $$('#stepThumbsList .mediaTarget').each(function (targetElement) {
         let mediaTarget = MediaTarget.createFromElement(targetElement, {
            customAttach: customMediaTargetAttach,
         });
         stepEditor.watchMediaTarget(mediaTarget);
         stepImageTargets.push(mediaTarget);
      });

      when($('mainGuideImage'), function (mainGuideImage) {
         let mediaTarget = MediaTarget.createFromElement(mainGuideImage);
         stepEditor.watchMediaTarget(mediaTarget);
      });

      let largeTarget = $$('#bigStepImage > .contents')[0];
      let enlargedTarget = stepImageTargets[0];

      updateLargeImage(enlargedTarget);

      Array.each(stepImageTargets, function (mediaTarget) {
         let target = mediaTarget.element;
         // When a target is filled in, ensure it gets moved into the Sortables
         // collection.
         mediaTarget.addEvent('itemChanged', function (mediaItem, oldMediaItem) {
            // if we are attaching a media item to the target
            if (mediaItem && !oldMediaItem) {
               $('step-thumbs').grab(target);
               sortableStepImages.addItems(target);
               // if the target becomes empty, move to the empties department
            } else if (!mediaItem && oldMediaItem) {
               $('step-thumb-empties').grab(target);
               sortableStepImages.removeItems(target);
            }

            // If this change even is happening on the target currently displayed
            // in the "large" target, update it.
            if (mediaTarget == enlargedTarget) {
               // If an item is deleted, mediaItem will be null, so we'll
               // default to showing the first MediaTarget.
               let mediaTargetToDisplay = mediaItem ? mediaTarget : stepImageTargets[0];
               updateLargeImage(mediaTargetToDisplay);
            }
         });

         // When hovering over a target, fill the stepImage div with the current
         // image.
         target.addEvent('mouseenter', function () {
            if (mediaTarget.mediaItem) {
               updateLargeImage(mediaTarget);
            }
         });
      });

      /**
       * Update the larger image above the three media targets with the
       * contents of the given mediaTarget.
       */
      function updateLargeImage(mediaTarget) {
         let mediaItem = mediaTarget.mediaItem;
         enlargedTarget = mediaTarget;

         let size = 'standard';
         if (!mediaItem) {
            largeTarget.adopt(MediaTarget.createModifyableIndicator('addImage', size));
            return;
         }

         // When the media Item is finished processing:
         mediaItem.whenReady(function () {
            let display = mediaItem.createDisplay(size);
            // When the image is preloaded
            display.whenReady(function () {
               largeTarget.empty();
               if (currentDisplay) {
                  currentDisplay.dispose();
               }
               let displayElement = display.getElement();
               displayElement.adopt(MediaTarget.createModifyableIndicator('replaceImage', size));
               largeTarget.adopt(displayElement);
               currentDisplay = display;
            });
         });
      }
      let currentDisplay;

      /**
       * Clicking the larger image should be the same as clicking on the target
       * that it is visualizing.
       */
      largeTarget.addEvent('click', function () {
         enlargedTarget.fireEvent('browse');
      });

      // eslint-disable-next-line no-var
      var sortableStepImages = new Sortables('step-thumbs', {
         clone: true,
         opacity: 0.2,
         onSort: stepEditor.getSetModifiedFunction(),
      });
   });

   let mediaTypeButtons = $$('#mediaTypeToggle button');

   let stepObject = $('stepObject');

   if (stepObject) {
      // eslint-disable-next-line no-var
      var objectTarget = MediaTarget.createFromElement(stepObject, {
         iconClass: 'addVideo',
         customAttach: customMediaTargetAttach,
      });

      stepEditor.watchMediaTarget(objectTarget);

      /**
       * Setup the Step Type toggle
       */
      mediaTypeButtons.addEvent('click', function () {
         setStepMediaMode(this.get('data-value'));
      });
   }

   /**
    * Hide or show the approporiate Step Type pane (image / object) and update
    * the media_type form field.
    */
   function setStepMediaMode(mediaType) {
      mediaTypeButtons.each(function (button) {
         button.toggleClass('active', button.get('data-value') === mediaType);
      });
      let mediaTypeElement = $('stepMediaType'),
         imagesPane = $('stepMediaImages'),
         objectPane = $('stepMediaObject'),
         typeIsImage = mediaType == 'image';

      mediaTypeElement.set('value', mediaType);
      imagesPane.toggleClass('hidden', !typeIsImage);
      objectPane.toggleClass('hidden', typeIsImage);
   }

   /**
    * Attach the item to the target and give it the option to veto the
    * attachment. Checks for, confirms, and accepts placing the wrong type of
    * media on a given target.
    *
    * @param mediaItem the item to attach
    * @param finished(oldItem, success) callback that will be called when the
    *        item has been attached.
    */
   function customMediaTargetAttach(mediaItem, finished) {
      let target = this;
      let itemType = mediaItem && mediaItem.getType();
      let confirmMessage;
      let newStepType;

      // Placing a video or embed on image target
      if (mediaItem && itemType != 'GuideImage') {
         if (target !== objectTarget) {
            confirmMessage = _js(
               'Placing this media will remove any images on this step. Do you want to continue?'
            );
         }
         target = objectTarget;
         newStepType = 'object';

         // Placing image on video target
      } else if (mediaItem && itemType === 'GuideImage' && target === objectTarget) {
         let emptyTarget = stepImageTargets.find(function (mediaTarget) {
            return !mediaTarget.mediaItem;
         });
         if (!emptyTarget) {
            alert(_js('Please change the step type and choose an image to replace.'));
            return finished();
         }
         confirmMessage = _js(
            'Placing this image will clear the media from this step. Do you want to continue?'
         );
         target = emptyTarget;
         newStepType = 'image';
      } else if (mediaItem && mediaItem.data.filter_state() !== true) {
         alert(target.getErrorMessage(mediaItem));
         return finished(mediaItem, false);
      }

      let confirmed = !confirmMessage || confirm(confirmMessage);
      if (confirmed) {
         // eslint-disable-next-line no-var
         var oldItem = target._immediatelyAttach(mediaItem);
         if (newStepType) {
            setStepMediaMode(newStepType);
         }
      }

      if (finished) {
         finished(oldItem, confirmed);
      }
   }

   function getFormValues() {
      let formValues;

      if (App.stepApi.isTranslate) {
         formValues = {
            title: getTitle(),
            lines: getLines(),
         };
      } else {
         formValues = {
            title: getTitle(),
            lines: getLines(),
            media: getMedia(),
         };
      }

      if (App.stepApi.orderby) {
         formValues.orderby = App.stepApi.orderby;
      }

      return formValues;
   }

   function getTitle() {
      let titleInput = $('editStepTitleInput');
      return titleInput ? titleInput.get('value') : '';
   }

   function getLines() {
      let lines = [];

      treeEditor.lines.each(function (line) {
         lines.push({
            text: line.source,
            bullet: line.bullet,
            level: line.level,
         });
      });

      return lines;
   }

   function getMedia() {
      let mediaType = $('stepMediaType').value.toUpperCase();

      return {
         type: mediaType,
         data: mediaType === 'IMAGE' ? getStepImageData() : getStepObjectData(),
      };
   }

   function getStepImageData() {
      return $('step-thumbs')
         .getElements('input')
         .map(function (image) {
            return image.value.toInt();
         });
   }

   function getStepObjectData() {
      return $('stepObject').getElement('input').value.toInt();
   }

   function handleHelp() {
      if ($$('.modalOpen').length) {
         return;
      }

      Modal.open({
         type: 'element',
         element: $('shortcuts-modal'),
      });
   }

   function handlePreviousStep() {
      window.location = App.previousStepLink;
   }

   function handleNextStep() {
      window.location = App.nextStepLink;
   }

   let keyNav = new KeyboardNavigation({
      keys: {
         'S-;': handleNextStep,
         'S-h': handlePreviousStep,
         'S-/': handleHelp,
      },
   });
});
